import Swiper from 'swiper/bundle'
import 'swiper/css/bundle'

globalThis.Swiper = Swiper